import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { NgbActiveModal, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "rask-tpl-handelser-remove-ao-warning",
    templateUrl: "./tpl-handelser-remove-ao-warning.component.html",
    styleUrls: ["./tpl-handelser-remove-ao-warning.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ButtonComponent]
})
export class TplHandelserRemoveAoWarningComponent {
    readonly activeModal = inject(NgbActiveModal);

    header: string;
    message: string;

    static open(header: string, message: string, modalService: NgbModal, callBack: (result: any) => void = null) {
        const options = {
            keyboard: false,
            backdrop: "static",
            centered: true
        } as NgbModalOptions;
        const modalRef = modalService.open(this, options);
        modalRef.componentInstance.header = header;
        modalRef.componentInstance.message = message;
        if (callBack) {
            modalRef.result.then(r => callBack(r));
        } else {
            modalRef.result.then(r => modalRef.close(r));
        }
    }

    setResponse(value: boolean) {
        this.activeModal.close(value);
    }

}
